import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { useSelector } from 'react-redux'
import styled from 'styled-components'
import { setSelectedMenu, setSelectedPage } from '../../../features/admin5/admin5Slice'
import { FaPlus } from "react-icons/fa";
import { FaArrowTurnUp } from "react-icons/fa6";
import { FaRegTrashAlt } from "react-icons/fa";
import { showModal, showNestedModal } from '../../../features/modal/modalSlice'

const Container = styled.div`
    width: 45%;
    height: 100%;
    
    .title{
        font-size: var(--font-size-lg);
        font-weight: var(--font-weight-lg);
        margin-bottom: 20px;
        text-align: center;
    }
    .page-list{
        display: flex;
        flex-direction: column;
        gap: 15px;
        border: 2px solid ;
        border-color: ${({ theme }) => theme.mainBorderColor};
        padding: 20px;
        border-radius: 10px;
        .page-info{
            font-size: var(--font-size-sm);
            font-weight: var(--font-weight-md);
        }
        .menu-item{
            display: flex;
            flex-direction: column;
            gap: 10px;
            .item-menu{
                font-size: var(--font-size-md);
                font-weight: var(--font-weight-md);
                color: ${({ theme }) => theme.textColor};
                cursor: pointer;
                border: 1px solid var(--color-main);
                padding: 10px;
                border-radius: 10px;
            }
            .selected-menu{
                background-color: var(--color-main) !important;
                color: white !important;
            }
            .permission-list{
                display: flex;
                flex-direction: column;
                padding: 0px 20px;
                .permission-item{
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    cursor: pointer;
                    border-bottom: 1px solid ${({ theme }) => theme.mainBorderColor};
                    padding-block: 15px;
                    .icon-title{
                        display: flex;
                        align-items: center;
                        gap: 5px;
                        svg{
                            transform: rotate(90deg);
                        }
                    }
                    .item-page{
                        font-size: var(--font-size-sm);
                        font-weight: var(--font-weight-md);
                    }
                    .selected-page{
                        color: var(--color-main) !important;
                    }
                }
                
            }
        }
    }
`
const newMenu = {
    id: 0,
    name: "Yeni Menü Oluştur",
}

const AdminSayfalarBox = () => {

    const dispatch = useDispatch()
    const { adminOrUserClaims } = useSelector((state) => state.companyAuthorization)
    const { selectedMenu, selectedPage } = useSelector((state) => state.admin5)

    const handleSelectMenu = (menu) => {
        if(menu === selectedMenu) {
            dispatch(setSelectedMenu(null))
            dispatch(setSelectedPage(null))
        }else{
            dispatch(setSelectedMenu(menu))
            dispatch(setSelectedPage(null))
        }
    }

    const handleSelectPage = (e, page) => {
        e.stopPropagation()
        if(page === selectedPage) {
            dispatch(setSelectedPage(null))
        }else{
            dispatch(setSelectedPage(page))
        }
    }

    
  return (
    <Container>
        <p className='title'>Menüler</p>
        <div className="page-list">

            {/* <div onClick={() => handleSelectMenu(newMenu)} className={`page-item ${selectedMenu?.id === newMenu?.id ? 'selected' : ''}`} >
                <p><FaPlus /> Menü Oluştur</p>
            </div>
            {selectedMenu?.id === 0 &&
                <div className="page-info">
                    <p>Bu seçenek ile eklerseniz alt sayfa olarak değil yan menü olarak eklenecektir.</p>
                </div>
            } */}

            {adminOrUserClaims?.slice(1)?.map((item) => (
                <div key={item.id} className={`menu-item`}>
                    <p onClick={() => handleSelectMenu(item)} className={`item-menu ${selectedMenu === item ? 'selected-menu' : ''}`} >{item.name}</p>
                    <div className="permission-list">
                        {selectedMenu?.id === item?.id && selectedMenu?.permission?.$values.map((permission) => (
                            <div className='permission-item' key={permission.id}>
                                <div className="icon-title">
                                    <FaArrowTurnUp />
                                    <p onClick={(e) => handleSelectPage(e, permission)} className={`item-page ${selectedPage === permission ? 'selected-page' : ''}`}>{permission.description}</p>
                                </div>
                                <div className="delete">
                                    <FaRegTrashAlt onClick={(e) => {e.stopPropagation(); dispatch(showNestedModal("adminDeletePage")); dispatch(setSelectedPage(permission))}} />
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            ))}
        </div>
    </Container>
  )
}

export default AdminSayfalarBox